<template>
    <div class="page-container">
        <Header></Header>
        <div class="page-header">
            <p style="font-family: 'Mansalva', cursive; color: white; letter-spacing: 4px;">just blogg it</p>
            <div class="page-scroll-down" style="display: inline-block;">
                <b-icon @click="goToFirstArticle" id="icon" icon="arrow-down-circle-fill" style="width: 90px; height: 90px; color: #FFD700;"></b-icon>
            </div>
        </div>
        <BlogArticle></BlogArticle>
        <Footer></Footer>
    </div>
</template>

<script>

    import Header from "@/components/Header";
    import Footer from "@/components/Footer";
    import BlogArticle from "@/components/BlogArticle";

    export default {
        name: "AllBlogsPage",
        components: {Footer, Header, BlogArticle },
        methods: {
            goToFirstArticle: function () {
                window.scrollTo(0,400);
            }
        }
    }
</script>

<style scoped>

    .page-container {
        background: linear-gradient(to left, black, #202020);
    }

    .page-header {
        height: auto;
        font-size: 100px;
        margin-top: 5vh;
        margin-bottom: 5vh;
    }

    .page-scroll-down {
        width: 100%;
        height: 150px;
        background: linear-gradient(to left, black, #202020);
        position: relative;
    }

    #icon {
        position: relative!important;
        z-index: 20!important;
    }

    .page-scroll-down p {
        font-family: 'Mansalva', cursive;
        font-size: 40px;
        color: #FFD700;
        margin-top: -15px;
    }

    @media only screen and (max-width: 374px) {
        .page-header {
            font-size: 33px;
        }
    }

    @media only screen and (min-width: 374px) and (max-width: 599px) {
        .page-header {
            font-size: 41px;
        }
    }

    @media only screen and (min-width: 600px) and (max-width: 759px) {
        .page-header {
            font-size: 60px;
        }
    }

    @media only screen and (min-width: 760px) and (max-width: 1000px) {
        .page-header {
            font-size: 80px;
        }
    }


</style>
